export class WaitUntilCompleteCommandResponse
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Handle any custom mappings here
        }
   }

    FailureCode: number = null;
    Header: string;
    MessageId: string;
    ParentId: number;
    ResponseText: string = null;
    TargetId: number;
    WasSuccess = false;
}
